<template>
  <div class="c-create-faq">
    <div class="faq-window">
      <n-card class="faq-card">
        <n-loader :loading="$var('load')" />
        <div class="card-top">
          <n-button flat @click="closeModal">X</n-button>
        </div>
        <div>
          <div class="faq-info">
            <n-items>
              <n-input title="Заголовок Ru" v-bind="$form.input('titleRu')"></n-input>
              <n-input title="Содержание Ru" v-bind="$form.input('contentRu')"></n-input>
              <n-input title="Заголовок Kz" v-bind="$form.input('titleKz')"></n-input>
              <n-input title="Содержание Kz" v-bind="$form.input('contentKz')"></n-input>
            </n-items>
          </div>
          <div class="button-save">
            <n-button color="primary" @click="save">Сохранить</n-button>
          </div>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CCreateFaq',
  data() {
    return {
      content: '',
      status: {},
    }
  },
  created() {
    this.$form.init({
      titleRu: '',
      contentRu: '',
      titleKz: '',
      contentKz: '',
    })
    this.$form.rules({
      titleRu: [ 'required', ],
      contentRu: [ 'required', ],
      titleKz: [ 'required', ],
      contentKz: [ 'required', ],
    })
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false)
    },
    save() {
      if (this.$form.check()) {
        this.$var('load', true)
        $api.faqs.create(this.$form.get()).then(() => {
          this.closeModal()
        }).finally(() => {
          this.closeModal()
          this.$var('load', false)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-create-faq {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .2);

  .button-save {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .card-top {
    display: flex;
    align-items: center;
    justify-content: right;
  }
}
</style>
